(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LayoutDesigner", [], factory);
	else if(typeof exports === 'object')
		exports["LayoutDesigner"] = factory();
	else
		root["LayoutDesigner"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition